export const TOKEN_COOKIE_KEY = 'uaa-token';

export const SESSION_EXTRACTOR_FULLSCREEN = 'session-extractor-fullscreen';
